import React, { useCallback, useEffect, useState } from "react";
import { SaveTable, Row } from "../../DataTable.jsx";

import { useDispatch } from "react-redux";

import { setPanelstrings } from "../../store/api";
import { NotificationManager } from "react-notifications";
import update from "immutability-helper";
import { useSiteConnected } from "../../store/connectionSlice.js";
import { useHwaddrFromRouter } from "../../store/sitesSlice.js";
import { useHwaddrAndNetworkIdFromRouter, usePanel, useZonesInUseCount } from "../../store/panelsSlice.js";
import { useParams } from "react-router-dom";
const createBinder = (state, setState, setDirty) => useCallback((key) => ({
    value: state[key],
    onChange: (ev) => {
        setState(
            update(state, {
                [key]: { $set: ev.target.value }
            })
        );
        setDirty(true);
    },
}), [state, setState]);

export const AboutTab = () => {
    const { hwaddr, networkId } = useParams();

    const enabled = useHwaddrFromRouter(useSiteConnected);
    const panel = useHwaddrAndNetworkIdFromRouter(usePanel);
    const zoneCount =useHwaddrAndNetworkIdFromRouter(useZonesInUseCount); //TODO - no, needs to be zones in use

    const loading = panel == null; //useSelector(isPanelLoading);

    const dispatch = useDispatch();

    const [isDirty, setDirty] = useState(false);

    const [editState, setEditState] = useState({
        panelName: "",
        panelCompanyName: "",
        panelSiteName: "",
        panelPhoneNumber: "",
    });

    useEffect(() => {
        if(!isDirty && panel != null)
        {
            setEditState({
                panelName: panel.strName,
                panelCompanyName: panel.strCompany,
                panelSiteName: panel.strSite,
                panelPhoneNumber: panel.strPhoneNumber,
            });
        }
    }, [
        panel
    ]);

    const bind = createBinder(editState, setEditState, setDirty);

    const onSave = useCallback(() => {
        if (enabled) {
            dispatch(setPanelstrings(
                hwaddr, networkId,
                
                editState.panelName,
                editState.panelCompanyName,
                editState.panelSiteName,
                editState.panelPhoneNumber
            ))
                .then(() => {
                    setDirty(false);
                    NotificationManager.success("Panel info updated.");
                });
        }
    }, [editState])

    if(loading)
    {
        return null;
    }

    return (
        <SaveTable disabled={!isDirty} onSave={onSave}>
            <Row label="Network name (RS485)">
                <input
                    maxLength={47}
                    disabled={!enabled}
                    className="form-control"
                    type="text"
                    {...bind("panelName")}
                />
            </Row>
            <Row label="Installer">
                <input
                    maxLength={47}
                    disabled={!enabled}
                    className="form-control"
                    type="text"
                    {...bind("panelCompanyName")}
                />
            </Row>
            <Row label="Site">
                <input
                    maxLength={47}
                    disabled={!enabled}
                    className="form-control"
                    type="text"
                    {...bind("panelSiteName")}
                />
            </Row>
            <Row label="Phone Number">
                <input
                    maxLength={47}
                    disabled={!enabled}
                    className="form-control"
                    type="text"
                    {...bind("panelPhoneNumber")}
                />
            </Row>
            <Row label="Zones">{zoneCount}</Row>
            <Row label="Connected?">{enabled ? "Yes" : "No"}</Row>
        </SaveTable>
    );

};